import { type ReactNode } from 'react';

import { useFillViewportHeight } from '../hooks/useFillViewportHeight.ts';

/**
 * Bounded, viewport-filling scroll box for the matrix grids. Inside it,
 * a `.snap-grid` with `.snap-grid__col-header` cells pins its header row
 * to the top and any `.is-frozen` label cells to the left (see the
 * `.snap-matrix-sticky` rules in tokens.css).
 *
 * The box bleeds to the page's right + bottom edges (negative margins
 * cancel the page content padding — 60px right / 48px bottom on the
 * Layout content, including its widened settings state) and moves the
 * breathing room inside as scroll-area padding, so the matrix fills the
 * viewport without being clipped at an inset frame.
 */
export function MatrixScrollBox({ children }: { children: ReactNode }) {
  const ref = useFillViewportHeight<HTMLDivElement>(0);
  return (
    <div
      ref={ref}
      className="snap-matrix-sticky"
      style={{
        marginRight: -60,
        marginBottom: 'calc(var(--12u) * -1)',
        paddingRight: 96,
        paddingBottom: 'var(--6u)',
      }}
    >
      {children}
    </div>
  );
}
